import {Component} from '@angular/core'
import {messagesEn} from './core/i18n/messages.en'
import {Form} from '../../../form-editor/src'
import {PersistanceService} from './core/persistance/persistance.service'

@Component({
  selector: 'app-root',
  styleUrls: ['./app.component.scss'],
  template: `
    <app-header></app-header>
    <main class="body">
      <fe-form-editor
        baseUrl="mock url"
        formId="mock id"
        [weights]="weights"
        [messages]="messages"
        (changed)="onChange($event)"
        (errorCallback)="onError($event)"></fe-form-editor>
    </main>
  `,
})
export class AppComponent {

  readonly weights: [1, 2, 3]

  readonly messages = messagesEn

  constructor(private persistanceService: PersistanceService) {
  }

  onChange(form: Form) {
    this.persistanceService.persistForm(form)
  }

  onError(e: string) {
    console.log(e)
  }
}
